import React from "react";
import Media from "react-responsive";

import Navbar from "../components/general/navbar/Navbar";
import Footer from "../components/general/Footer";
import ScrollMenu from "../components/pages/projects/ScrollMenu";
import StaticMenu from "../components/pages/projects/StaticMenu";

import MobileFuture from "../components/mobile/MobileFuture";
import MobileNavbar from "../components/mobile/MobileNavbar";
import MobileFooter from "../components/mobile/MobileFooter";

const Projects = () => {
  return (
    <div className="flex flex-col">
      <div>
        <Media query="(max-width: 768px)">
          {(isMobile) =>
            isMobile ? (
              <MobileNavbar />
            ) : (
              <Navbar absolute={false} color="navy" />
            )
          }
        </Media>
      </div>
      <div className="flex flex-col justify-center items-center text-center p-3 md:p-5">
        <div className="w-full text-center">
            <h1 className="pb-5 text-4xl font-display font-regular text-navy animate-fadein">
              Future Work
            </h1>
          </div>
        <Media query="(max-width: 768px)">
          {(isMobile) =>
            isMobile ? <ScrollMenu /> : <StaticMenu />
          }
        </Media>
      </div>
      <div className="animate-fadein">
        <MobileFuture />
      </div>
      <div className="mt-8">
        <Media query="(max-width: 768px)">
          {(isMobile) => (isMobile ? <MobileFooter /> : <Footer />)}
        </Media>
      </div>
    </div>
  );
};

export default Projects;
